 <div role="heading" class="media-width-headerfooter" aria-level="1" tabindex="0" [innerHTML]="headerString | headerFooterHtml"></div>